export const mediaType = {
  IMAGE: 'Photo',
  VIDEO: 'Video',
  SIGN: 'HtmlAd',
  WEBPAGE: 'WebPage',
};

export const mediaTypesAccepted = '.jpeg,.jpg,.png,.mp4';
